// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_MENU_ADD_BAZAAR_PRODUCT = "Inzeruj v baz\u00e1ri";
export const ADD_MENU_ADD_BLOG_POST = "Nap\u00ed\u0161 pr\u00edspevok";
export const ADD_MENU_ADD_DISCUSSION = "Zalo\u017e diskusiu";
export const ADD_MENU_ADD_REVIEW = "Pridaj recenziu";
export const ADD_MENU_SUBTITLE_AD = "Pon\u00fakni veci na predaj";
export const ADD_MENU_SUBTITLE_DISCUSSION = "Sp\u00fdtaj sa na sk\u00fasenosti, zdie\u013eaj svoj pr\u00edbeh";
export const ADD_MENU_SUBTITLE_POST = "Pode\u013e sa o moment, tip, in\u0161piruj ostatn\u00fdch";
export const ADD_MENU_SUBTITLE_RECIPE = "In\u0161piruj ostatn\u00fdch svojimi kulin\u00e1rskymi n\u00e1padmi";
export const ADD_MENU_SUBTITLE_REVIEW = "Pridaj hodnotenie, pom\u00f4\u017ee\u0161 ostatn\u00fdm";
export const ADD_RECIPE = "Pode\u013e sa o svoj recept";
export const HOMEPAGE_ADD_BUTTON = "Pridaj";
